import { runtime } from '../Runtime';
export class RuntimeHostname {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get runtime() {
        return this.parent;
    }
    get subdomain() {
        if (runtime.isDevelopmentStage)
            return 'dev';
        if (runtime.isQualityStage)
            return 'qs';
        return 'www';
    }
    get nodeHostName() {
        if (runtime.isDevelopmentStage)
            return 'devnode.schlaukopf.de';
        if (runtime.isQualityStage)
            return 'qsnode.schlaukopf.de';
        return 'node.schlaukopf.de';
    }
    get dataHostName() {
        return `${this.subdomain}.schlaukopf.de`;
    }
    get data2HostName() {
        if (runtime.isDevelopmentStage)
            return 'devnode.schlaukopf.de';
        return 'node.schlaukopf.de';
    }
}
